<template>
  <!-- <v-img
      src="@/assets/wave_green_top.svg"
    ></v-img> -->
  <v-container class="prefooter-container m-0 p-0" fluid>
    <div
      class="d-flex ga-10 flex-column justify-center align-center h-100"
      v-if="false"
    >
      <template v-if="route.name !== 'Home'">
        <div class="holitime-is">
          Holitime <span class="text-secondary">c'est ...</span>
        </div>
        <div class="d-flex flex-column flex-md-row text-center ga-80">
          <div>
            <span class="holi-stats">40 millions</span> <br />
            <span class="holi-stats-title">Patients</span>
          </div>
          <div>
            <span class="holi-stats">700 000</span> <br />
            <span class="holi-stats-title">Praticiens</span>
          </div>
          <div>
            <span class="holi-stats">94%</span> <br />
            <span class="holi-stats-title">D’avis positifs</span>
          </div>
        </div>
      </template>
    </div>
    <!-- <v-img
      class="prefooter-img"
      cover
      src="@/assets/prefooter.svg"
    >
    </v-img> -->
  </v-container>
</template>

<script lang="ts" setup>
import { useRoute } from 'vue-router'

const route = useRoute()
</script>

<style scoped>
.prefooter-container {
  width: 100%;
  height: 470px;
  /* filter: grayscale(1); */
  padding: 0;
  margin: 0;
  /* background-color: rgba(18, 194, 155, 0.05); */
  background-image: url('@/assets/home/prefooter-back.png');
  background-size: cover;
  background-position-x: center;
}

.prefooter-img > img {
  filter: grayscale(1);
  position: relative !important;
}

.prefooter-img {
  filter: grayscale(1);
  padding-bottom: 0px !important;
}

.ga-80 {
  gap: 80px;
}

@media (max-width: 600px) {
  .ga-80 {
    gap: 30px !important;
  }
}

.holitime-is {
  font-weight: 700;
  color: #616161;
  font-size: 33px;
  line-height: 140%;
  letter-spacing: -0.66;
}

.holi-stats {
  font-weight: 700;
  font-size: 40px;
  line-height: 130%;
  color: #616161;
}

.holi-stats-title {
  font-weight: 700;
  font-size: 19px;
  line-height: 140%;
  color: #d6b25d !important;
}
</style>
